export default async function postArchivo(body) {
  const endpoint = localStorage.getItem("endpoint");
  const url = endpoint + "adm_archivos/archivos";
  const js = JSON.stringify(body);

  try {
    const config = { method: "POST", headers: {}, body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
